import React from "react";
import "./HeadlineArea.css";

const HeadlineArea = () => {
  return (
    <section className="self-publishing-headline-section">
      <div className="hero-content">
        <h1 className="hero-title">반기획 출판</h1>
      </div>
    </section>
  );
};

export default HeadlineArea;
